<section
  class="tw-flex tw-flex-col tw-m-auto tw-p-4 md:tw-px-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
  id="public-info"
>
  <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-1 tw-items-start">
    <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">{{ 'v2.orgSettings.publicInfo.publicInfo' | translate }}</h2>
    <p class="tw-text-sm tw-max-w-[660px] tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
      {{ 'v2.orgSettings.publicInfo.title' | translate }}
    </p>
  </div>
  <div class="tw-flex tw-flex-col tw-gap-6">
    @if (!isLoading()) {
    <form
      class="tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl tw-p-4 tw-flex tw-flex-col md:tw-flex-col lg:tw-flex-row tw-gap-1 lg:tw-gap-4"
      [formGroup]="publicInfoFormGroup()"
    >
      <!-- Upload input -->
      <div class="tw-w-full md:tw-w-[144px] lg:tw-w-[152px] lg:tw-flex-shrink-0 tw-mb-3 md:tw-mb-4 lg:tw-mb-0">
        <app-upload
          [fileList]="publicInfoFormGroup().controls.organizationLogo"
          accept=".jpg, .png, .jpeg"
          [maxFileSize]="2 * 1024"
          [deleteFileWithAPI]="true"
          label="Organizer logo"
          [apiPayload]="{
            organization_id: organizationData()?.id,
            type: uploadTypeEnum.ORGANIZATION
          }"
          (fileChanged)="onLogoChanged($event)"
          (fileDeleted)="onLogoDeleted()"
        >
        </app-upload>
      </div>

      <!-- Fields container -->
      <div class="tw-flex tw-flex-col tw-flex-1 tw-gap-1">
        <basic-input
          [control]="publicInfoFormGroup().controls.workspaceName"
          [placeholder]="'v2.orgSettings.publicInfo.name' | translate"
          [id]="'organization-name'"
          [mode]="BasicInputMode.INLINE"
          [allowClearButton]="false"
          [required]="true"
          (onKeydown)="onChildKeydown($event)"
          (onBlurValueChange)="onBlur($event)"
        ></basic-input>

        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <email-input
            [control]="publicInfoFormGroup().controls.companyEmail"
            [icon]="publicInfoIcons.email"
            iconType="fill"
            [placeholder]="'v2.orgSettings.publicInfo.email' | translate"
            [mode]="BasicInputMode.INLINE"
            [id]="'organizer-email'"
            [allowClearButton]="false"
            (onKeydown)="onChildKeydown($event)"
            (onBlurValueChange)="onBlur($event)"
          ></email-input>

          <phone-input
            [control]="publicInfoFormGroup().controls.companyPhone"
            [icon]="publicInfoIcons.phone"
            iconType="fill"
            [placeholder]="'v2.orgSettings.publicInfo.phoneNumber' | translate"
            [id]="'organizer-phone-number'"
            [mode]="BasicInputMode.INLINE"
            [allowClearButton]="false"
            (onKeydown)="onChildKeydown($event)"
            (onBlurValueChange)="onBlur($event)"
          ></phone-input>
        </div>

        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <url-input
            [control]="publicInfoFormGroup().controls.companyWebsite"
            [icon]="publicInfoIcons.website"
            iconType="fill"
            [placeholder]="'v2.orgSettings.publicInfo.website' | translate"
            [id]="'organization-website'"
            [mode]="BasicInputMode.INLINE"
            [allowClearButton]="false"
            (onKeydown)="onChildKeydown($event)"
            (onBlurValueChange)="onBlur($event)"
          ></url-input>

          <url-input
            [control]="publicInfoFormGroup().controls.linkedinCompanyPage"
            [icon]="publicInfoIcons.linkedIn"
            iconType="fill"
            [placeholder]="'v2.orgSettings.publicInfo.orgLinkedIn' | translate"
            [id]="'organization-linkedIn'"
            [mode]="BasicInputMode.INLINE"
            [allowClearButton]="false"
            [urlPrefix]="'linkedin.com/'"
            (onKeydown)="onChildKeydown($event)"
            (onBlurValueChange)="onBlur($event)"
          ></url-input>
        </div>

        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <city-input
            [control]="publicInfoFormGroup().controls.city"
            [placeholder]="'v2.orgSettings.publicInfo.city' | translate"
            [icon]="publicInfoIcons.city"
            iconType="fill"
            [mode]="BasicInputMode.INLINE"
            (onKeydown)="onChildKeydown($event)"
            (onBlurValueChange)="onBlur($event)"
            (valueChanged)="onCityValueChange($event)"
          ></city-input>
        </div>
      </div>
    </form>
    <ngx-editor
      [message]="editorMessage() || organizationData()?.company_description || ''"
      [placeholder]="'v2.orgSettings.publicInfo.description' | translate"
      [showMenuBar]="false"
      [enableFloatingToolbar]="true"
      [maxCharacterLimit]="500"
      (valueChange)="onDescriptionChange($event)"
      (blurred)="onEditorBlur($event)"
    ></ngx-editor>
    }@else {
    <div class="tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl tw-p-4 tw-flex tw-flex-col md:tw-flex-col lg:tw-flex-row tw-gap-1 lg:tw-gap-4">
      <!-- Upload input skeleton -->
      <div class="tw-w-full md:tw-w-[144px] lg:tw-w-[152px] lg:tw-flex-shrink-0 tw-mb-3 md:tw-mb-4 lg:tw-mb-0">
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '100%', height: '26px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
          animation="pulse"
        ></ngx-skeleton-loader>
      </div>

      <!-- Fields container skeleton -->
      <div class="tw-flex tw-flex-col tw-flex-1 tw-gap-1">
        <!-- Company name skeleton -->
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '100%', height: '36px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
          animation="pulse"
        ></ngx-skeleton-loader>

        <!-- Email and Phone row skeleton -->
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '26px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '26px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>

        <!-- Website and LinkedIn row skeleton -->
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '26px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '26px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>

        <!-- City row skeleton -->
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 md:tw-gap-2 lg:tw-gap-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '26px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>

    <!-- Description editor skeleton -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '100%', height: '180px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
      animation="pulse"
    ></ngx-skeleton-loader>
    }
  </div>
</section>
